import { ModelContext, useValue } from '@morningtrain/react-resources'
import { observable } from 'mobx'

export default function ProvideNormForWeekday ({ children, weekday }) {
  const normObject = useValue('norms.' + weekday.index)

  if (!normObject || !normObject.norm_offset) {
    return null
  }

  return (
    <ModelContext.Provider value={observable.map(normObject)}>
      {children}
    </ModelContext.Provider>
  )
}
